import { inject, Injectable } from '@angular/core';
import Keycloak, {
    KeycloakConfig,
    KeycloakInitOptions,
    KeycloakProfile,
} from 'keycloak-js';
import { BehaviorSubject, Observable } from 'rxjs';
import { KeycloakUser } from '../models/keycloakUser';
import { HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root',
})
export class KeycloakService {
    private superAdminRecht: BehaviorSubject<boolean> =
        new BehaviorSubject<boolean>(false);
    private keycloakUser: KeycloakUser = new KeycloakUser();
    private keycloakUserBehaviorSubject: BehaviorSubject<KeycloakUser> =
        new BehaviorSubject<KeycloakUser>(this.keycloakUser);
    private keycloak!: Keycloak;
    private token: string = '';

    constructor(
        private router: Router,
        private translateService: TranslateService,
    ) {}

    init(config: KeycloakConfig, initOptions: KeycloakInitOptions) {
        this.keycloak = new Keycloak(config);
        this.keycloak
            .init(initOptions)
            .then((success) => {
                if (!success) {
                    this.keycloak.login();
                } else {
                    this.keycloak
                        .loadUserProfile()
                        .then((profile) => {
                            //    this.translateService = inject(TranslateService);
                            this.changeLanguage(profile);
                            let user = new KeycloakUser(
                                profile?.firstName,
                                profile?.lastName,
                                profile?.email,
                                profile?.username,
                                true,
                                this.keycloak.realmAccess?.roles ||
                                    new Array<string>(),
                                this.keycloak.token || '',
                            );
                            this.keycloakUser = user;
                            localStorage.setItem(
                                'SuperAdmin',
                                this.keycloak.realmAccess?.roles.includes(
                                    'SuperAdmin',
                                )
                                    ? 'true'
                                    : 'false',
                            );
                            this.superAdminRecht.next(
                                this.keycloak.realmAccess?.roles.includes(
                                    'SuperAdmin',
                                )
                                    ? true
                                    : false,
                            );
                            localStorage.setItem(
                                'Token',
                                this.keycloak.token || '',
                            );
                            localStorage.setItem('User', user.Username);
                            this.keycloakUserBehaviorSubject.next(user);
                            setInterval(async () => {
                                if (this.keycloak.isTokenExpired()) {
                                    await this.keycloak.updateToken(70); // 70 Sekunden Puffer
                                }
                            }, 60000);
                        })
                        .catch((error) => console.log(error));
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    changeLanguage(profile: KeycloakProfile): void {
        let locale =
            profile?.attributes && profile.attributes['locale']
                ? (profile.attributes['locale'] as Array<string>)
                : 'de';
        let language = 'de';
        if (locale?.length > 0) {
            switch (locale[0]) {
                case 'de': {
                    localStorage.setItem('Language', language);
                    break;
                }
                case 'en': {
                    language = 'en';
                    localStorage.setItem('Language', language);
                    break;
                }
                default: {
                    localStorage.setItem('Language', language);
                    break;
                }
            }
            this.translateService.use(language);
        }
    }

    getSuperAdmin(): Observable<boolean> {
        return this.superAdminRecht.asObservable();
    }

    getHttpHeader(): HttpHeaders {
        let token = localStorage.getItem('Token');
        return new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `${token}`,
        });
    }

    getHttpHeader2(): HttpHeaders {
        let token = localStorage.getItem('Token');
        return new HttpHeaders({
            enctype: 'multipart/form-data',
            Authorization: `${token}`,
        });
    }

    getKeycloakUser(): Observable<KeycloakUser> {
        return this.keycloakUserBehaviorSubject.asObservable();
    }

    logout() {
        this.keycloak.logout();
        this.keycloak.clearToken();
    }

    goToProfile() {
        this.keycloak.accountManagement().then((test) => {});
    }

    isInit(): boolean {
        return this.keycloak != null && this.keycloak != undefined;
    }

    updateToken(sek: number): void {
        this.keycloak.updateToken(sek).then((refresh) => {
            localStorage.removeItem('Token');
            localStorage.setItem('Token', this.keycloak.token || '');
        });
    }

    async refresh(): Promise<void> {
        this.keycloak.updateToken().then((token) => {
            localStorage.removeItem('Token');
            localStorage.setItem('Token', this.keycloak.token || '');
        });
    }

    goToLogin(): void {
        this.keycloak.login();
    }

    isTokenExpired(): boolean {
        return this.keycloak.isTokenExpired();
    }
    isLoggedIn(): boolean {
        return this.keycloak?.authenticated || false;
    }

    getToken(): string {
        return this.keycloak?.token || '';
    }
}
